// ======================================================================
// File Name       : ScoringReportContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { change, getFormValues, reduxForm } from 'redux-form';
import * as ContentActions from '../../../actions/ContentAction';
import * as groupActions from '../../../actions/GroupAction';
import * as ReportActions from '../../../actions/ScoringReportAction';
import Header from '../../../components/Header';
import MessageSearch from '../../../components/MessageSearch';
import ModalConductor from '../../../components/modal/ModalConductor';
import ReportListResult from '../../../components/report/scoring/ScoringReportListResult';
import ReportListSearch from '../../../components/report/scoring/ScoringReportListSearch';
import ReportListSearchTop from '../../../components/report/scoring/ScoringReportListSearchTop';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../../constants/AuthorityConstant';
import { SELECT_TARGET_DATA } from '../../../constants/index';
import * as ReportConstants from '../../../constants/ScoringReportConstants';
import { PRECENT_DAY, THE_PREVIOUS_SIX_MONTH } from '../../../utils';
import { hideLoading, showLoading } from '../../../utils/PageUtils';


class ReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startPosition: 0,
      reportHistorySortType: 1,
      ascendingDescendingSort: 1,
      isAllowShowSearchMessage: false,
      isValidUrl: true,
    };
    this.handleShowModal = this.handleShowModal.bind(this);
    this.searchReport = this.searchReport.bind(this);
    this.handleSearchReport = this.handleSearchReport.bind(this);
    this.handleShowGroupDlg = this.handleShowGroupDlg.bind(this);
    this.handleExportReportList = this.handleExportReportList.bind(this);
    this.handleBatchApproval = this.handleBatchApproval.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleGetReport = this.handleGetReport.bind(this);
    this.initData = this.initData.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.onChangeCheckboxTop = this.onChangeCheckboxTop.bind(this);
    this.handleButtonDisabled = this.handleButtonDisabled.bind(this);
    // #5854 START
    this.onRadioButtonChange = this.onRadioButtonChange.bind(this);
    this.validateData = this.validateData.bind(this);
    // #5854 END
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  initData(match, scoringManagementAuthority) {
    const updatedDateFrom = THE_PREVIOUS_SIX_MONTH;
    const updatedDateTo = PRECENT_DAY;
    const submissionDateFrom = THE_PREVIOUS_SIX_MONTH;
    const submissionDateTo = PRECENT_DAY;
    this.setState({
      ...this.state,
      startPosition: 0,
      reportHistorySortType: 1,
      ascendingDescendingSort: 1,
    });
    let mode = '';
    const isCorrectorPrivilege = scoringManagementAuthority !== MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT;
    let isValidUrl = false;
    if (match.params.mode) {
      mode = match.params.mode;
      if (Object.values(ReportConstants.REPORT_LIST_MODE).indexOf(mode) > -1) {
        isValidUrl = true;
      }
    }
    const data = {
      reportName: '',
      userSubmitter: '',
      groupSubmitter: '',
      checkerName: '',
      noSetCheckerFlg: false,
      submitted: false,
      checking: false,
      remand: false,
      pendingApproval: false,
      approved: false,
      resultReturned: false,
      includeDeadlineReportFlg: false,
      updatedDateFrom,
      updatedDateTo,
      // #6912 START
      // displayDate: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
      displayDate: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
      // #6912 END
      submissionDateFrom,
      submissionDateTo,
    };
    // set search condition null incase scoringManagementAuthority !== 2
    if (isCorrectorPrivilege) {
      data.userSubmitter = null;
      data.groupSubmitter = null;
      data.checkerName = null;
      data.noSetCheckerFlg = null;
      // data.displayDate = MANAGEMENT_AUTHORITY_TYPE.REFERENCE; // #6912
    }
    switch (mode) {
      case ReportConstants.REPORT_LIST_MODE.GET:
        data.noSetCheckerFlg = true;
        data.submitted = true;
        break;
      case ReportConstants.REPORT_LIST_MODE.CORRECTION:
        data.checking = true;
        data.remand = true;
        break;
      case ReportConstants.REPORT_LIST_MODE.APPROVAL:
        data.pendingApproval = true;
        break;
      case ReportConstants.REPORT_LIST_MODE.REMAND:
        data.pendingApproval = true;
        data.approved = true;
        data.resultReturned = true;
        break;
      case ReportConstants.REPORT_LIST_MODE.COMPULSORY_COLLECTION:
        data.checking = true;
        data.remand = true;
        break;
      case ReportConstants.REPORT_LIST_MODE.WITHDRAWAL:
        data.pendingApproval = true;
        break;
      case ReportConstants.REPORT_LIST_MODE.TOP:
        data.noSetCheckerFlg = true;
        // START #6031
        if (isCorrectorPrivilege) {
          data.pendingApproval = true;
          data.submitted = true;
          data.remand = true;
          data.checking = true;
        }
        // END #6031
        break;
      default:
        break;
    }
    this.setState({ isValidUrl });
    this.props.dispatch(
      ReportActions.scoringReportSearch(SELECT_TARGET_DATA.DATA, data, this.state)). then(() => {
        this.props.dispatch(hideLoading());
      });
    this.props.dispatch(ReportActions.initReportListSearchData(data, isValidUrl, mode));
    this.props.dispatch(groupActions.selectedGroupOnDialog({ groupName: '' }));
  }

  componentWillMount() {
    this.props.dispatch(showLoading());
    const { authedUser, skinCaches, match, mode } = this.props;
    match.params.mode = mode;
    const { managementFunctionAuthorityInfo } = authedUser;
    const { scoringManagementAuthority } = managementFunctionAuthorityInfo;
    const cachedIframe = $('.cached_skin');
    let shouldGetCacheSkin = true;
    if (skinCaches && skinCaches.allSkinSetSecernIds && skinCaches.allSkinSetSecernIds.length && cachedIframe && cachedIframe.length) {
      if (authedUser && authedUser.institutionId &&
          skinCaches && skinCaches.institutionId) {
        shouldGetCacheSkin = authedUser.institutionId !== skinCaches.institutionId;
      }
    }
    if (managementFunctionAuthorityInfo
      && managementFunctionAuthorityInfo.scoringManagementAuthority !== MANAGEMENT_AUTHORITY_TYPE.REFERENCE) {
      this.props.dispatch(groupActions.fetchGroupStructure());
    }
    if (shouldGetCacheSkin) {
      if (cachedIframe && cachedIframe.length) {
        cachedIframe.remove();
      }
      this.props.dispatch(ContentActions.cacheSkinList()).then(() => {
        this.initData(match, scoringManagementAuthority);
      });
    } else {
      this.initData(match, scoringManagementAuthority);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { authedUser, reportList, match, mode } = nextProps;
    match.params.mode = mode;
    const { managementFunctionAuthorityInfo } = authedUser;
    const { scoringManagementAuthority } = managementFunctionAuthorityInfo;

    if (match.params.mode !== reportList.mode) {
      this.props.dispatch(showLoading());
      this.initData(match, scoringManagementAuthority);
    }
  }

  handleShowModal(reportData) {
    const { dispatch } = this.props;
    dispatch(ReportActions.openReportDialog(reportData));
  }

  searchReport() {
    this.setState({
      ...this.state,
      startPosition: 0,
      isAllowShowSearchMessage: false,
    }, () => {
      this.handleSearchReport();
    });
  }

  handleSearchReport() {
    // #5854 START
    const isValid = this.validateData();
    if (!this.props.reportListForm ||
        !this.props.reportListForm.values ||
        !this.props.reportList || !isValid) return;
    // #5854 END
    const searchInfo = this.props.reportListForm.values;
    this.props.dispatch(
      ReportActions.scoringReportSearch(
        SELECT_TARGET_DATA.DATA,
        searchInfo,
        this.state,
        this.props.reportList.mode,
      ),
    ).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  handleShowGroupDlg() {
    const { dispatch } = this.props;
    dispatch(ReportActions.openGroupSelectDialog());
  }

  handleGetReport(data) {
    const params = {
      reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.ACQUISITION,
      reportListCheck: [
        {
          itemLearningHistoryReportIdAuto: data.itemLearningHistoryReportIdAuto,
        },
      ],
    };
    this.props.dispatch(ReportActions.editByCorrector(params)).then(() => {
      this.handleSearchReport();
    });
  }
  handleExportReportList() {
    if (!this.props.reportListForm ||
        !this.props.reportListForm.values ||
        !this.props.reportList) return;
    const searchInfo = this.props.reportListForm.values;
    this.props.dispatch(showLoading());
    this.props.dispatch(
      ReportActions.scoringReportSearch(
        SELECT_TARGET_DATA.CSV,
        searchInfo,
        this.state,
        this.props.reportList.mode,
      ),
    ).then(() => { this.props.dispatch(hideLoading()); });
  }
  handleBatchApproval() {
    const reportInfo = [];
    const listLength = this.props.searchResult.reportList.length;
    for (let i = 0; i < listLength; i++) {
      const item = {
        itemLearningHistoryReportIdAuto:
        this.props.searchResult.reportList[i].itemLearningHistoryReportIdAuto,
      };
      reportInfo.push(item);
    }
    const params = {
      reportOperationType: ReportConstants.REPORT_OPERATION_TYPE.APPROVAL,
      reportListAuthorize: reportInfo,
    };
    this.props.dispatch(ReportActions.editByCorrector(params));
    this.handleSearchReport();
  }
  handleSortState(row) {
    this.setState({
      startPosition: 0,
      reportHistorySortType: row.sortBy,
      ascendingDescendingSort: row.sortState,
    }, () => this.handleSearchReport());
  }
  getStartEndData(startPosition) {
    this.setState({
      startPosition,
    }, () => this.handleSearchReport());
  }

  removeSelectedGroup() {
    this.props.dispatch(ReportActions.removeGroupSelectDialog(null));
    this.props.dispatch(change('reportListForm', 'selectedTargetGroup', null));
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }
  onChangeCheckboxTop(event, newValue, previousValue) {
    if (newValue && !previousValue) {
      this.props.change('checkerName', '');
    }
  }
  // #5854 START
  validateData() {
    let isValid = true;
    if (this.refsToValidate) {
      const refsToValidate = this.refsToValidate[0].refsToValidate;
      refsToValidate.forEach((ref) => {
        if (ref.validation && !ref.validation()) {
          isValid = ref.validation();
        }
      });
    }
    return isValid;
  }
  // Handle reset date incase of selecting radio button
  onRadioButtonChange(event) {
    if (event.target.value === MANAGEMENT_AUTHORITY_TYPE.REFERENCE.toString()) {
      this.props.change('submissionDateFrom', THE_PREVIOUS_SIX_MONTH);
      this.props.change('submissionDateTo', PRECENT_DAY);
    } else {
      this.props.change('updatedDateFrom', THE_PREVIOUS_SIX_MONTH);
      this.props.change('updatedDateTo', PRECENT_DAY);
    }
  }
  // #5854 END
  handleButtonDisabled(buttonId) {
    this.props.dispatch(ReportActions.handleButtonDisabled(buttonId));
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }
  render() {
    this.refsToValidate = [];
    const { reportList, searchResult, authedUser, formValues, groupList, mode } = this.props;
    const { managementFunctionAuthorityInfo } = authedUser;
    const { scoringManagementAuthority } = managementFunctionAuthorityInfo;
    const { isValidUrl, hoverIndex } = this.state;
    if (!isValidUrl) {
      return <Redirect to="/top" />;
    }
    return (
      <div>
        <MessageSearch
          recordNum={searchResult.recordNum}
          resultList={searchResult.reportList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        {formValues && reportList && mode !== ReportConstants.REPORT_LIST_MODE.TOP &&
        <ReportListSearch
          searchInfo={formValues}
          onShowGroupDialog={this.handleShowGroupDlg}
          onSearchReport={this.searchReport}
          mode={reportList.mode}
          scoringManagementAuthority={scoringManagementAuthority}
          removeSelectedGroup={this.removeSelectedGroup}
          groupList={groupList}
          // #5854 START
          onRadioButtonChange={this.onRadioButtonChange}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          // #5854 END
        />}
        {formValues && reportList && mode === ReportConstants.REPORT_LIST_MODE.TOP &&
        <ReportListSearchTop
          searchInfo={formValues}
          onShowGroupDialog={this.handleShowGroupDlg}
          onSearchReport={this.searchReport}
          scoringManagementAuthority={scoringManagementAuthority}
          removeSelectedGroup={this.removeSelectedGroup}
          // #5854 START
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          // #5854 END
          formValues={formValues}
          onChangeCheckboxTop={this.onChangeCheckboxTop}
          groupList={groupList}
          onRadioButtonChange={this.onRadioButtonChange}
        />}
        {reportList && <ReportListResult
          handleButtonDisabled={this.handleButtonDisabled}
          onShowDetail={this.handleShowModal}
          reportList={searchResult.reportList}
          onExportReportList={this.handleExportReportList}
          onBatchApproval={this.handleBatchApproval}
          handleSortState={this.handleSortState}
          recordNum={searchResult.recordNum}
          getStartEndData={this.getStartEndData}
          startPosition={this.state.startPosition}
          onGetReport={this.handleGetReport}
          mode={reportList.mode}
          scoringManagementAuthority={scoringManagementAuthority}
          dataSort={this.state}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />}
        <ModalConductor
          onCloseScoringReportDialog={this.handleSearchReport}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { reportListForm } = state.form;
  const { reportList } = { ...state.scoringReport };
  const { userInfo } = state.user;
  const { submitterInfo } = state.user;
  const { checkerInfo } = state.user;
  const { structures, groupList } = state.group;
  const { selectedTargetGroup } = state.group;
  const { searchResult } = state.scoringReport;
  const { authedUser } = state.authed;
  const { skinCaches } = state.content;
  let data = {};
  if (reportList && reportList.data) {
    data = { ...reportList.data };
    if (selectedTargetGroup) {
      data.groupSubmitter = selectedTargetGroup.groupName;
      data.selectedTargetGroup = selectedTargetGroup;
    } else {
      data.groupSubmitter = '';
      data.selectedTargetGroup = null;
    }
  }
  return {
    ...{ reportListForm },
    ...{ reportList },
    ...{ userInfo },
    ...{ structures },
    ...{ selectedTargetGroup },
    ...{ searchResult },
    ...{ submitterInfo },
    ...{ checkerInfo },
    ...{ authedUser },
    ...{ skinCaches },
    initialValues: data,
    formValues: getFormValues('reportListForm')(state),
    groupList,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'reportListForm', // a unique identifier for this form
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  touchOnChange: true,
})(ReportContainer));
